import { memo, useRef, useEffect } from 'react'
import classNames from 'classnames'
import gsap from 'gsap'
import { createUseStyles } from 'react-jss'
import style from './style'

const useStyles = createUseStyles(style)

const AnimatingSpiral = ({
  className,
}) => {
  const classes = useStyles()
  const $path = useRef()

  useEffect(() => {
    const dash = $path.current.getTotalLength().toFixed(0)
    gsap.set($path.current, {
      strokeDasharray: `${dash} ${dash}`,
    })

    gsap.to($path.current, {
      duration: 4,
      strokeDashoffset: `${dash * 2}`,
      ease: 'power2.inOut',
      repeat: -1,
    })
  }, [])

  return (
    <svg
      className={classNames({
        [classes.root]: true,
        [className]: className,
      })}
      viewBox="0 0 240 240"
    >
      <path ref={$path} d="M205.6,154.4c-24,52-77.8,56.5-93.3,56.5c-17.4,0-75-1.8-75-77.3c0-66,55.6-103.4,90.6-103.4 c30.6,0,57,13.8,57,46.7s-41.7,52-65.2,52c-20.5,0-35.4-4.7-35.4-4.7" />
    </svg>
  )
}

export default (memo(AnimatingSpiral))
